import { render, staticRenderFns } from "./Password_rest.vue?vue&type=template&id=dd7c3060&"
import script from "./Password_rest.vue?vue&type=script&lang=js&"
export * from "./Password_rest.vue?vue&type=script&lang=js&"
import style0 from "./Password_rest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports